module.exports = __webpack_public_path__ + "static/cursor-active-f3eabeb891127e67385cbd32c7ef4d39.svg";